const updates = [
  { date: '2026-08-01', title: '《流浪地球3》高清完整版正式上线片多多影视', tag: '新片上线' },
  { date: '2026-07-30', title: '平台全面升级4K超清画质，观影体验再度提升', tag: '功能升级' },
  { date: '2026-07-28', title: '《长安十二时辰》全48集高清版已更新完毕', tag: '剧集更新' },
  { date: '2026-07-25', title: '新增悬疑推理专题频道，百部高分烧脑片等你来看', tag: '专题上线' },
  { date: '2026-07-22', title: '《乘风破浪的姐姐》最新一期舞台纯享版已上线', tag: '综艺更新' },
  { date: '2026-07-20', title: '片多多影视日活跃用户突破500万，感谢每一位影迷', tag: '平台动态' },
  { date: '2026-07-18', title: '动漫频道新增200+部番剧，日漫国漫一网打尽', tag: '内容扩充' },
  { date: '2026-07-15', title: '播放器全面优化，片多多高清不卡体验再上新台阶', tag: '技术升级' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
            <p className="mt-3 text-sm text-foreground-500">片多多影视最新资讯</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 md:pl-10">
              <div className="absolute left-3 md:left-3.5 top-0 bottom-0 w-px bg-background-300"></div>

              <div className="space-y-6 md:space-y-8">
                {updates.map((item, i) => (
                  <div key={i} className="relative">
                    <div className={`absolute -left-[29px] md:-left-[29px] top-1 w-3 h-3 rounded-full border-2 ${
                      i === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-background-300'
                    }`}></div>
                    <div className="bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-200/50 transition-colors cursor-pointer">
                      <div className="flex flex-wrap items-center gap-2 mb-2">
                        <span className="text-xs text-foreground-500">{item.date}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                          i === 0 ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                        }`}>
                          {item.tag}
                        </span>
                      </div>
                      <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}